export const getClientCredentialsState = store => store.clientCredentials;
